// extracted by mini-css-extract-plugin
var _1 = "tjs-timer-section__section";
var _2 = "tjs-timer-section__timer-container";
var _3 = "tjs-timer-section__timer-container";
export { _1 as "section", _2 as "timer-container", _3 as "timerContainer" }
export default { "section": _1, "timer-container": _2, "timerContainer": _3 }
